import React from "react";
import ReactDOM from "react-dom/client";

// Bridge Vite env to globalThis so App.jsx works in both Vite and non-Vite contexts
globalThis.__VITE_DEMO__ = import.meta.env.VITE_DEMO_MODE === "true";

import BarrelRank from "./App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BarrelRank />
  </React.StrictMode>
);
